import React from 'react'
import { timeToString } from '../../../util'

/**
 * @param timeLimit: Immutable // From table
 * @param timeRemaining // As in player class
 * @param onTurnSince // As in player class
 */
class PlayerClock extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            computedTimeRemaining: this.getComputedTimeRemaining(props)
        }
        this._isMounted = true
        this.updateTime()
    }

    componentWillUnmount()
    {
        this._isMounted = false
    }

    getComputedTimeRemaining(props = this.props)
    {
        return props.onTurnSince ? (
            Math.max(0, this.props.timeRemaining - (new Date().getTime() - props.onTurnSince))
        ) : (
            this.props.timeRemaining
        )
    }

    updateTime()
    {
        if (this._isMounted) {
            setTimeout(() => {
                this.setState({ computedTimeRemaining: this.getComputedTimeRemaining() })
                this.updateTime()
            }, 100)
        }
    }

    render()
    {
        const timeLimit = this.props.timeLimit
        if (timeLimit.get("base") == -1) {
            return null // Unlimited time
        } else {
            const critical = this.state.computedTimeRemaining < 5000
            const timeRemainingPct = Math.max(0, Math.min(1, this.state.computedTimeRemaining / timeLimit.get("base")))
            const timeStringPcs = timeToString(this.state.computedTimeRemaining).split(":")

            return (
                <div className={ "player-clock " + (critical ? "critical" : "") }>
                    <div
                        className="progress-bar"
                        style={{ transform: "scaleX(" + timeRemainingPct + ")" }}
                    />
                    <div className="clock">
                        <div className="time">
                            { timeStringPcs[0] + ":" + timeStringPcs[1] }
                        </div>
                        <div className="millis">
                            { timeStringPcs[2].charAt(0) }
                        </div>
                    </div>
                </div>
            )
        }
    }

}

export default PlayerClock
export { PlayerClock }